/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
    "account": "Akun",
    "active_date": "Tanggal aktif",
    "address": "Alamat",
    "address2": "Alamat 2 (Opsional)",
    "amount": "Jumlah",
    "and": "dan",
    "article": "Artikel",
    "buy": "Pembelian",
    "buyer": "Pembeli",
    "buyer_info": "Informasi pembeli",
    "cancel": "Batal",
    "canceled": "Dibatalkan",
    "cellphone": "Ponsel",
    "certification_expires": "Tidak sah atau kedaluwarsa, silakan masuk kembali",
    "change_password": "Ubah kata sandi",
    "city": "Kota",
    "clear": "Bersihkan",
    "commercial": "Komersial",
    "company": "Perusahaan",
    "completed": "Selesai",
    "confirm_password": "Konfirmasi Kata Sandi",
    "contact": "Kontak",
    "country": "Negara",
    "create": "Buat",
    "create_account": "Buat akun",
    "create_date": "Tanggal Pembuatan",
    "creationdate": "Tanggal Pembuatan",
    "currency": "Mata Uang",
    "customer_success": "Pendaftaran berhasil, silakan cek email untuk aktivasi",
    "dead_line": "Batas waktu",
    "dealer": "Dealer",
    "dealer_success": "Menunggu persetujuan",
    "description": "Deskripsi",
    "domain": "Domain",
    "domain_in_use": "Domain sudah digunakan",
    "email": "Email",
    "email_format_error": "Format email salah",
    "email_used": "Email sudah digunakan",
    "enter_character": "Masukkan karakter pada gambar",
    "enter_confirm_password": "Masukkan kata sandi baru lagi",
    "enter_new_password": "Masukkan kata sandi baru",
    "enter_old_password": "Masukkan kata sandi lama",
    "erp_list": "Langganan",
    "erp_status": "Status",
    "expire_date": "Tanggal kedaluwarsa",
    "female": "Perempuan",
    "first_name": "Nama Depan",
    "forget_password": "Lupa kata sandi",
    "forgot_password": "Lupa kata sandi?",
    "form_not_exist": "Formulir tidak ada",
    "format_error": "Kesalahan Format",
    "group_code": "Kode grup",
    "group_name": "Nama Grup",
    "home_company_address": "Alamat rumah/perusahaan",
    "image": "Gambar",
    "information_success": "Perubahan informasi akun berhasil",
    "initial_info": "Info awal",
    "input_password": "Masukkan kata sandi",
    "input_password_again": "Silakan masukkan kata sandi lagi",
    "last_name": "Nama belakang",
    "legal_person": "Badan hukum",
    "male": "Laki-laki",
    "modify": "Ubah",
    "modify_erp_information": "Ubah info ERP",
    "modules": "Modul",
    "month": "Pengguna/bulan",
    "name": "Nama",
    "new_password": "Kata Sandi Baru",
    "new_password_toEmail": "Kata sandi baru telah dikirim ke email Anda",
    "next": "Berikutnya",
    "noFoundurl": "Instance tidak ada",
    "not_null": "Ada kolom wajib belum diisi",
    "official_website": "Situs resmi:",
    "ok": "OK",
    "old_password": "Kata Sandi Lama",
    "old_password_error": "Kata sandi lama tidak cocok",
    "one_time_payment": "Pembayaran sekali",
    "operation": "Operasi",
    "or": "ATAU",
    "order": "Pesanan",
    "order-no": "No pesanan",
    "order_close": "Pesanan telah ditutup",
    "order_list": "Daftar pesanan",
    "order_no": "No. Pesanan",
    "order_status": "Status pesanan",
    "other": "Lainnya",
    "paid": "Lunas",
    "password": "Kata Sandi",
    "password_error": "Kata sandi harus 6-20 karakter kombinasi huruf dan angka",
    "password_error_two": "Kata sandi tidak sama",
    "password_least": "Kata sandi minimal 6 karakter dengan angka dan huruf/karakter khusus",
    "password_strength": "Kekuatan Kata Sandi",
    "pay": "Pembelian",
    "pay_error": "Gagal mengambil info pembayaran",
    "payment": "Metode pembayaran",
    "payment_date": "Tanggal Pembayaran",
    "personal": "Pribadi",
    "please_email": "Periksa email Anda",
    "pos": "Posisi",
    "previous": "Sebelumnya",
    "price": "Harga",
    "privacy": "Dengan membuat akun SOMATIME, Anda setuju",
    "privacy_notice": "Kebijakan privasi",
    "product": "Produk",
    "product_list": "Daftar produk",
    "product_name": "Nama Produk",
    "purchase": "Pembelian",
    "purchase_success": "Pembelian berhasil",
    "refunded": "Dikembalikan",
    "registered": "Email sudah terdaftar",
    "registered_email_address": "Kami telah mendaftar dengan email Anda",
    "renewal": "Perpanjangan",
    "repeat_password": "Ulangi kata sandi",
    "requied": "Wajib",
    "requied_num": "Hanya angka",
    "require_tips": "Data pembeli tidak lengkap",
    "required": "Wajib",
    "reseller": "Reseller",
    "resend": "Kirim ulang",
    "reset_password": "Email konfirmasi kata sandi telah dikirim ke",
    "revoke": "Batalkan pesanan",
    "revoke_tip1": "Tutup pesanan saat ini?",
    "role": "Peran",
    "search": "Cari",
    "send_update": "Kirim update dari SOMATIME",
    "sex": "Jenis Kelamin",
    "signIn": "Masuk",
    "sign_out": "Keluar",
    "state": "Provinsi",
    "status": "Status pembayaran",
    "status_not_match": "Status tidak sesuai",
    "strength_high": "Tinggi",
    "strength_low": "Rendah",
    "strength_mid": "Tengah",
    "submit": "Kirim",
    "submitted": "Terkirim",
    "subscribe": "Berlangganan",
    "subscribe-mon": "Langganan-bulanan",
    "subscript_success": "Berlangganan berhasil",
    "telephone": "Telepon",
    "tenant_list": "Daftar tenant",
    "tenant_management_system": "Sistem manajemen tenant",
    "tenant_system": "Sistem tenant",
    "terms_of_use": "Syarat penggunaan",
    "time_info": "Info waktu",
    "title": "Judul",
    "unpaid": "Belum Dibayar",
    "update_password_success": "Kata sandi berhasil diubah",
    "user": "Pengguna",
    "user_check": "Silakan baca dan setujui kebijakan privasi dan syarat penggunaan",
    "user_id": "ID pengguna",
    "user_month": "Bulan",
    "user_not_active": "Pengguna belum aktif",
    "user_not_exist": "Pengguna tidak ada",
    "user_password_error": "Kata sandi salah",
    "user_qty": "Jumlah pengguna",
    "username": "Nama pengguna",
    "ver_code_error": "Kode verifikasi salah",
    "ver_code_exd": "Kode verifikasi kedaluwarsa",
    "visit": "Kunjungi",
    "welcome_to_iceq": "SELAMAT DATANG DI SOMATIME",
    "zip": "Kode pos",
    "trial": "Uji coba",
    "requesting_a_trial": "Pengajuan berhasil! Info demo akan dikirim dalam 24 jam",
    "trial_orders_have_been_requested": "Permintaan trial telah dibuat",
    "apply_trial": "Minta demo",
    "request_": "Permintaan",
    "trial_": "Uji coba",
    "on_trial": "Dalam uji coba",
    "order_not_exist": "Pesanan tidak ada",
    "wait_for_payment": "Menunggu pembayaran",
    "trial_reject": "Demo ditolak",
    "tips": "Tips",
    "confirm": "Konfirmasi",
    "cancel": "Batal",
    "trial_only_allow_one_time_payment_method": "Trial hanya bisa pembayaran sekali",
    "domain_info": "Info domain",
    "please_fill_in_domain_info": "Isi info domain",
    "user_quantity_and_month_required": "Jumlah pengguna & bulan wajib",
    "password_must_be_the_same": "Konfirmasi harus sama",
    "enter_the_password_and_new_password": "Masukkan sandi & sandi baru",
    "wrong_user_name_and_password": "Username/sandi salah",
    "close_the_page_without_saving": "Tutup tanpa simpan?",
    "cancel_input": "Batalkan input",
    "user_does_not_exist": "Pengguna tidak ada",
    "modify_success": "Berhasil diubah",
    "email_has_been_used": "Email sudah dipakai",
    "created_successfully": "Berhasil dibuat",
    "error_tip_10098": "Email gagal, hubungi admin",
};